export function GetCartItems(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/GetCartItems?shopCode='+data.ShopCode, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function GetCartItemsCount() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/GetCartItemsCount', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

// export function GetCartItems(data) {
//     return new Promise((resolve) =>
//         setTimeout(() =>
//             resolve(
//                 fetch(data.ShopCode === "C" ? './JSON/cartItem2a.json' : './JSON/cartItem2p.json', {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json; charset=utf-8',
//                         'access-control-allow-origin': '*',
//                         'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
//                     }
//                 })
//                     .then(res => res.json())
//                     .then((data) => {
//                         return data;
//                     })
//                     .catch((error) => {
//                         console.error('Error:', error);
//                     })
//             )
//         ), 0)
// }

// export function GetCartItemsCount() {
//     return new Promise((resolve) =>
//         setTimeout(() =>
//             resolve(
//                 fetch('./JSON/cartcount.json', {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json; charset=utf-8',
//                         'access-control-allow-origin': '*',
//                         'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
//                     }
//                 })
//                     .then(res => res.json())
//                     .then((data) => {
//                         return data;
//                     })
//                     .catch((error) => {
//                         console.error('Error:', error);
//                     })
//             )
//         ), 0)
// }

export function GetPriceRule() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/GetPriceRule', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function DuplicateCart(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/DuplicateCart', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function DeleteCart(id) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/DeleteCart', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify({
                        "CartItemId": id
                    })
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}
